import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../services/user.service';
import { environment } from '../../../environments/environment';
import { isThisSecond } from 'date-fns';
@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.less']
})
export class DepartmentComponent implements OnInit {
  isCollapsed = false;
  departmentId:string;
  loading = false;
  perPage = 10;
  page = 1;
  employees:any=[];
  department:any=[];
  dataParam:any=[];
  employeesTotal:number;
  imgBaseURL =  environment.apiUrl + '/static/';
  getFullYear: number = new Date().getFullYear();

  getUrl(){
    this.routerLinkActive.paramMap.subscribe((params:any)=>{
      this.departmentId = params.get('name');
      this.getEmployees();
    })
  }

  getEmployees(){
    this.loading = true;

    const arr = [
      'dept='+ this.departmentId,
      'work_status=0'
    ];

    const dataParam = arr.filter((e) => { return e != ""; }).join('&');

    this.userService.getEmployee(-1, 1, dataParam).subscribe((res:any)=>{
      this.department = res.data.department;
      this.employees = res.data.data;      
      this.employeesTotal = res.data.total;
      this.loading = false;
      this.getDepartment();
    });
  }
  
  getDepartment(){
    this.userService.getDepartmentId(this.departmentId).subscribe((res) => {
      this.department = res.data.department;      
    })
  }

  constructor(
    private readonly routerLinkActive: ActivatedRoute,
    private userService:UserService,
  ) { }

  ngOnInit() {
    this.getUrl();
  }



}
